import { React } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

function PhoneChangeInput(props) {
  const { value, setValue, placeholder, onClickCheck, isCheckedPhone, setIsCheckedPhone, originalPhone, checkButton = true } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  function onChangeInput(e) {
		setValue(e.target.value);
    setIsCheckedPhone(false);
  }

  function calcButtonColor() {
    if (isCheckedPhone) return theme.subText;
    else if (value === originalPhone) return theme.line;
    else return theme.subKey;
  }

  return (
    <TopLevelWrapper>
      <Input
        $fullWidth={!checkButton}
        placeholder={placeholder}
        value={value || ''}
        onChange={onChangeInput} />
      {checkButton &&
        <CheckButton onClick={onClickCheck} backgroundColor={calcButtonColor()}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subBackground}>{t('memberDetail.verify')}</Text>
        </CheckButton>
      }
    </TopLevelWrapper>
  )
}

export default PhoneChangeInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 32px;

  gap: 5px;
`;

const Input = styled.input`
  width: ${props => props.$fullWidth ? 'calc(100% - 18px)' : 'calc(70% - 18px)'};
  height: calc(100% - 2px);

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  color: ${props => props.theme.text};

  padding: 0 8px 0 8px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  outline: none;

  background-color: ${props => props.disabled ? props.theme.line : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  ::placeholder {
    color: ${props => props.theme.subText};
  }
`;

const CheckButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 26.19%;
  height: 32px;

  border-radius: 5px;
  background-color: ${props => props.backgroundColor};

  &:hover { 
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  }
`;
